const config = () => ({
  adSkipTimeDurationInSeconds: 10,
  videoTypeThresholdInSeconds: 90,
  adMidrollThresholdInSeconds: 180,
  adMidrollOffsetInPercent: 0.5,
  gallery: {
    firstAdAfterXSlides: 2,
    showAdAfterXSlides: 5,
  },
  admeira: {
    storageKey: 'admeira',
    appnexus: {
      version: '2.10.0',
      environment: 'prod',
      publisherId: 'blick.ch_de',
      publisherId___romandie: 'blick.ch_fr',
      articleIdKeyName: 'articleid',
      articleIdKeyName___romandie: 'articleid_fr',
      fallbackChannel: 'ROS',
      channelMapping: {
        News: 'News',
        Schweiz: 'News',
        Ausland: 'News',
        Digital: 'Digital',
        People: 'People',
        Sport: 'Sport',
        Meinung: 'Meinung',
        Politik: 'Politik',
        Wirtschaft: 'Wirtschaft',
        Leben: 'Leben',
        Mobil: 'Auto',
        Video: 'Video',
        'Test Section Home': 'Home',
      },
      channelMapping___romandie: {
        News: 'News',
        Suisse: 'News',
        Monde: 'News',
        Opinion: 'Opinion',
        'Tech & Science': 'Tech',
        Sport: 'Sport',
        Lifestyle: 'Life',
        Vidéos: 'Videos',
      },
    },
  },
})

export type configType = ReturnType<typeof config>
export default config
